export default __webpack_public_path__ + "static/media/277.bfdddaea.png";